import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_customers_export_modal_test",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "exportCustomerCsvModalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  id: "kt_customers_export_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y mx-5 mx-xl-15 my-7" }
const _hoisted_8 = { class: "fv-row mb-10" }
const _hoisted_9 = ["value", "label"]
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = ["data-kt-indicator"]
const _hoisted_12 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_13 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_14 = {
  key: 1,
  class: "indicator-progress"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "fw-bolder" }, "Export Users", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, {
                src: "/media/icons/duotune/arrows/arr061.svg",
                "aria-hidden": "true"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { class: "fs-5 fw-bold form-label mb-5" }, "Select Export Year:", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedYear) = $event)),
              class: "form-control"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearsList, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item,
                  value: item,
                  label: item
                }, null, 8, _hoisted_9))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedYear]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "reset",
              id: "kt_customers_export_cancel",
              class: "btn btn-light me-3",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onHideModal && _ctx.onHideModal(...args)))
            }, " Discard "),
            _createElementVNode("button", {
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
              class: "btn btn-lg btn-primary"
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                    _cache[5] || (_cache[5] = _createTextVNode(" Submit ", -1)),
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_inline_svg, {
                        src: "icons/duotune/arrows/arr064.svg",
                        "aria-hidden": "true"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, [...(_cache[6] || (_cache[6] = [
                    _createTextVNode(" Please wait... ", -1),
                    _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
                  ]))]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_11)
          ])
        ])
      ])
    ])
  ], 512))
}